import type { FC, SVGProps } from 'react'

export const CD: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.5 4C7.5 3.72386 7.72386 3.5 8 3.5C10.4853 3.5 12.5 5.51472 12.5 8C12.5 8.27614 12.2761 8.5 12 8.5C11.7239 8.5 11.5 8.27614 11.5 8C11.5 6.067 9.933 4.5 8 4.5C7.72386 4.5 7.5 4.27614 7.5 4Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.00033 6.16675C6.98781 6.16675 6.16699 6.98756 6.16699 8.00008C6.16699 9.0126 6.9878 9.83341 8.00033 9.83341C9.01285 9.83341 9.83366 9.0126 9.83366 8.00008C9.83366 6.98756 9.01285 6.16675 8.00033 6.16675ZM7.16699 8.00008C7.16699 7.53984 7.54009 7.16675 8.00033 7.16675C8.46056 7.16675 8.83366 7.53984 8.83366 8.00008C8.83366 8.46032 8.46056 8.83341 8.00033 8.83341C7.54009 8.83341 7.16699 8.46032 7.16699 8.00008Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.833496 8.00004C0.833497 4.042 4.04212 0.833373 8.00016 0.833374C11.9582 0.833375 15.1668 4.042 15.1668 8.00004C15.1668 11.9581 11.9582 15.1667 8.00016 15.1667C4.04212 15.1667 0.833495 11.9581 0.833496 8.00004ZM8.00016 1.83337C4.59441 1.83337 1.8335 4.59428 1.8335 8.00004C1.8335 11.4058 4.59441 14.1667 8.00016 14.1667C11.4059 14.1667 14.1668 11.4058 14.1668 8.00004C14.1668 4.59428 11.4059 1.83337 8.00016 1.83337Z"
      fill="currentColor"
    />
  </svg>
)
